import styled from 'styled-components';
import { useIsModernizedSegmentationPageEnabled } from 'modules/segmentation/hooks';
import { BUTTON_VARIANTS } from 'ui/button';
import { LongArrowRight, Undo } from 'ui/icons';
import { SuccessfulUpload } from 'ui/illustrations';
import { LinkButton } from 'ui/linkButton';
import { Table } from 'ui/table';
import { ColumnData } from 'ui/tableHeader';
import { TableRows } from 'ui/tableRows';
import { Link } from 'ui/links';
import { Body1 } from 'ui/theme';
import { SemanticUI } from '@iterable/deprecated_react_components';
import { ListPropertyCell, PropertyContentCell } from './Panel3';

interface Panel4 {
  listName: string;
  listDescription: string;
  listType: string;
  rowCount: number;
  listId: number;
}

type RowContent = {
  row: {
    listProperty: string;
    propertyContent: string;
  };
};

const StyledBody1 = styled(Body1)`
  text-align: center;
`;

const CenteredIcon = styled.div`
  text-align: center;
`;

export function Panel4Content({ listName, listDescription, listType, rowCount, listId }: Panel4) {
  const isModernizedSegmentationPageEnabled = useIsModernizedSegmentationPageEnabled();
  return (
    <div>
      <CenteredIcon>
        <SuccessfulUpload />
      </CenteredIcon>
      <StyledBody1>Your list has been created!</StyledBody1>
      <Table>
        <TableRows
          columns={[
            {
              name: 'ListProperty',
              value: 'listProperty',
              align: 'flex-start',
              sortable: false,
              RowCell: ({ row }: RowContent) => (
                <ListPropertyCell>{row.listProperty}</ListPropertyCell>
              ),
            } as ColumnData,
            {
              name: 'PropertyContent',
              value: 'propertyContent',
              align: 'flex-start',
              sortable: false,
              RowCell: ({ row }: RowContent) => (
                <PropertyContentCell>{row.propertyContent}</PropertyContentCell>
              ),
            } as ColumnData,
          ]}
          rows={[
            {
              id: 1,
              listProperty: 'List name',
              propertyContent: (
                <div>
                  {listName}{' '}
                  <Link
                    href={`/segmentation?emailListId=${listId}`}
                    useReactRouter={isModernizedSegmentationPageEnabled}
                  >
                    {' '}
                    <strong>
                      {' '}
                      View the list
                      <LongArrowRight height={10} width={20} />
                    </strong>
                  </Link>
                </div>
              ),
            },
            {
              id: 2,
              listProperty: 'List description',
              propertyContent: listDescription,
            },
            {
              id: 3,
              listProperty: 'List type',
              propertyContent: listType,
            },
            {
              id: 4,
              listProperty: 'Total rows',
              propertyContent: rowCount,
            },
          ]}
          selectedRows={[]}
        />
      </Table>

      <SemanticUI.Divider />

      <LinkButton variant={BUTTON_VARIANTS.GHOST} to="/lists/import" isAngular>
        <Undo height={20} width={20} /> Upload another list
      </LinkButton>
    </div>
  );
}
